import Api from '@/services/api'

export default {
  get_single(params) {
    return Api().get(`document/${params.id}`)
  },
  get_multiple(params) {
    return Api().get('document', { params: params });
  },
  get_uploaded_all(params) {
    return Api().get('uploadeddocument/all', { params: params });
  },
  get_all(params) {
    return Api().get('document/all', { params: params });
  },
  toggle_user(params) {
    return Api().post(`document/toggle/${params.document_id}/${params.user_id}`);
  },
  get_premium(params) {
    return Api().get(`document/premium/${params.user_id}`);
  },
  save(params) {
    return Api().put(`document/${params.id}`, params );
  },
  delete(params) {
    return Api().delete(`document/${params}`, params );
  },
  create(params) {
    return Api().post(`document/create`, params );
  }
}